/**
 * Clean phone number - removes country codes and non-digit characters
 * @param {string} phoneNumber - Phone number to clean
 * @returns {string} - Cleaned phone number (digits only)
 */
export const cleanPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';
  
  // Remove all non-digit characters
  let cleaned = phoneNumber.replace(/\D/g, '');
  
  // Remove common country codes (India: +91, 91, 0)
  if (cleaned.startsWith('91') && cleaned.length > 10) {
    cleaned = cleaned.substring(2);
  } else if (cleaned.startsWith('0') && cleaned.length > 10) {
    cleaned = cleaned.substring(1);
  }
  
  // Return only first 10 digits (Indian mobile number format)
  return cleaned.substring(0, 10);
};

